
import { useState } from 'react';

interface ConfirmationDialogState {
  isOpen: boolean;
  onConfirm: () => Promise<void>;
}

export const useConfirmationDialog = () => {
  const [dialog, setDialog] = useState<ConfirmationDialogState>({
    isOpen: false,
    onConfirm: async () => {}
  });

  const openConfirmDialog = (confirmHandler: () => Promise<void>) => {
    setDialog({
      isOpen: true,
      onConfirm: confirmHandler
    });
  };

  const closeConfirmDialog = () => {
    setDialog(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const handleConfirm = async () => {
    closeConfirmDialog();
    await dialog.onConfirm();
  };

  return {
    isDialogOpen: dialog.isOpen,
    openConfirmDialog,
    closeConfirmDialog,
    handleConfirm
  };
};
